import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import VideoStream from "./VideoStream";
import { useDataContext } from "./contexts/DataProvider";
import welcome from "./1.png";
import VideoPlayer from "./videoPlayer";

const CustomLayoutWithMarquee = () => {
  const { dashboard } = useDataContext();

  const currentSetting =
    dashboard.length > 0 ? dashboard[0].setting_name : null;

  return (
    <div
      className="d-flex flex-column"
      style={{ height: "100vh", width: "100vw", overflow: "hidden" }}
    >
      {/* Main Content Area */}
      <div className="d-flex" style={{ flex: 1, overflow: "hidden" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "white",
            overflow: "hidden",
          }}
        >
          {currentSetting === "live" && (
            <VideoStream currentSetting="live" />
          )}

          {currentSetting === "kirtan" && (
            <VideoStream currentSetting="kirtan" />
          )}

          {currentSetting === "welcome" && (
            <img style={{ width: "100%", height: "100%", objectFit: "contain" }} src={welcome} alt="Welcome" />
          )}

          {currentSetting === "gurbani" && <VideoPlayer />}
        </div>
      </div>
    </div>
  );
};

export default CustomLayoutWithMarquee;
